import { useRef } from 'react';
const useTaskFormRefs = ({ taskType, }) => {
    const titleTranslationsRefs = [
        ['titleDE', useRef(null)],
        ['titleEN', useRef(null)],
        ['titleCS', useRef(null)],
    ];
    const descriptionTranslationsRefs = [
        ['descriptionDE', useRef(null)],
        ['descriptionEN', useRef(null)],
        ['descriptionCS', useRef(null)],
    ];
    const coordinatesLonRef = useRef(null);
    const coordinatesLatRef = useRef(null);
    const radiusRef = useRef(null);
    const orderedRefs = [
        ...titleTranslationsRefs,
        ['taskType', useRef(null)],
        ...descriptionTranslationsRefs,
        ['fileReference', useRef(null)],
        ...(taskType === 'location'
            ? [
                ['coordinatesLat', coordinatesLatRef],
                ['coordinatesLon', coordinatesLonRef],
                ['radius', radiusRef],
            ]
            : []),
        ['successPoints', useRef(null)],
        ['failurePoints', useRef(null)],
    ];
    return { refs: Object.fromEntries(orderedRefs), orderedRefs };
};
export default useTaskFormRefs;
